import { render, staticRenderFns } from "./ValidationBoxWrapper.vue?vue&type=template&id=2c72a3ce"
import script from "./ValidationBoxWrapper.vue?vue&type=script&lang=ts"
export * from "./ValidationBoxWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports